const Selectors = {
  CONTAINER: '#error-notification-container',
  TEXT: '#error-notification-msg',
  INNER: '#error-notification-inner',
};

const Styles = {
  HIDE: 'hide'
};

const Attribs = {
  EXPANDED: 'aria-expanded',
  HIDDEN: 'aria-hidden',
};

function toggle(isVisible: boolean, msg: string = '') {
  const container = document.querySelector<HTMLElement>(Selectors.CONTAINER);
  if (!isVisible) {
    container?.classList.add(Styles.HIDE);
  } else {
    container?.classList.remove(Styles.HIDE);
    const textElement = document.querySelector<HTMLElement>(Selectors.TEXT);
    if (textElement) {
      textElement.innerText = msg;
    }
  }
  container?.setAttribute(Attribs.EXPANDED, String(isVisible));
  document.querySelector(Selectors.INNER)?.setAttribute(Attribs.HIDDEN, String(!isVisible));
}

export default {
  show(msg: string) {
    if (!msg) {
      return;
    }
    toggle(true, msg);
  },
  hide() {
    toggle(false);
  }
};
